import * as React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Intro from '../Intro/Intro';
import DrillSelector from '../DrillSelector/DrillSelector';
import Manual from '../Manual/Manual';
import { Global, css } from '@emotion/core';
import styled from '@emotion/styled';

const Container = styled('div')`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgb(62,62,62);
`;

type Components =
  'Intro' |
  'DrillSelector' |
  'Manual';

interface State {
  username: string;
  password: string;
  loggedIn: boolean;
  userList: string[];
  passwordList: string[];
  currentComponent: Components;
}

/**
 * 
 */
class DrillsApp extends React.Component<{}, State> {
  constructor (props: any) {
    super(props);

    this.state = {
      username: '',
      password: '',
      loggedIn: true,
      userList: ['admin'],
      passwordList: ['password'],
      currentComponent: 'Intro'
    };

    this.setUsernamePassword = this.setUsernamePassword.bind(this);
    this.authenticateLogin = this.authenticateLogin.bind(this);
    this.changeSelectedComponent = this.changeSelectedComponent.bind(this);
  };

  /**
   * 
   * @param {React.FormEvent<HTMLInputElement>} event 
   */
  setUsernamePassword(event: React.FormEvent<HTMLInputElement>): void {
    if (event.currentTarget.name === 'username') {
      this.setState({
        username: event.currentTarget.value,
      });
    };

    if (event.currentTarget.name === 'password') {
      this.setState({
        password: event.currentTarget.value
      })
    };
  }

  /**
   * 
   * @param {React.FormEvent<HTMLInputElement>} event 
   */
  authenticateLogin(event: React.FormEvent<HTMLInputElement>): void {
    let userIndex = this.state.userList.indexOf(this.state.username);

    if (userIndex >= 0) {
      if (this.state.password === this.state.passwordList[userIndex]) {
        console.log('logged in');
        this.setState({
          loggedIn: true
        });
      } else {
        return;
      }
    } else {
      return;
    }
  }

  changeSelectedComponent(value: Components): void {
    this.setState({
      currentComponent: value,
    });
  };

  render (state = this.state) {
    return (
      <Container>
        <Global
          styles={css`
            @font-face {
              font-family: 'Roboto';
              font-style: normal;
              font-weight: 400;
              font-display: swap;
              src: local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v19/KFOmCnqEu92Fr1Mu4mxK.woff2) format('woff2');
              unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            /* latin */
            @font-face {
              font-family: 'Roboto';
              font-style: normal;
              font-weight: 700;
              font-display: swap;
              src: local('Roboto Bold'), local('Roboto-Bold'), url(https://fonts.gstatic.com/s/roboto/v19/KFOlCnqEu92Fr1MmWUlfBBc4.woff2) format('woff2');
              unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            body, html {
              border: 0;
              margin: 0;
              padding: 0;
            }

            body {
              font-size: 16px;
            }

            * {
              box-sizing: border-box;
              font-family: Roboto, Arial, Helvetica, sans-serif;
            }

            li, p {
              line-height: 1.4;
            }
          `}
        />
        <Header
          selected={ this.state.currentComponent }
          handleComponentSelect={ this.changeSelectedComponent }
        />
        {
          this.state.currentComponent === 'Intro' &&
          <Intro />
        }
        {
          this.state.currentComponent === 'Manual' &&
          <Manual />
        }
        {
          this.state.currentComponent === 'DrillSelector' &&
          <DrillSelector />
        }
        <Footer />
      </Container>
    );
  }
}

export default DrillsApp;

export {
  Components
};
